import { render } from "./HeroSmall.vue?vue&type=template&id=67ab3068&scoped=true"
import script from "./HeroSmall.vue?vue&type=script&lang=js"
export * from "./HeroSmall.vue?vue&type=script&lang=js"

import "./HeroSmall.vue?vue&type=style&index=0&id=67ab3068&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ab3068"]])

export default __exports__